
import { ReactNode } from 'react';

interface PageContentProps {
  pageNumber: number;
  children: ReactNode;
}

const PageContent = ({ pageNumber, children }: PageContentProps) => {
  let title = "";
  
  // Determine page title based on page number
  switch(pageNumber) {
    case 1:
      title = "THE CREED";
      break;
    case 2:
      title = "THE BROCORE VALUES";
      break;
    case 3:
      title = "THE RANKS OF BRODOM";
      break;
    case 4:
      title = "THE SYSTEM OF PROOF";
      break;
    case 5:
      title = "THE BROSCORE ECONOMY";
      break;
    case 6:
      title = "THE LAW";
      break;
    default:
      title = "";
  }
  
  return (
    <div className="space-y-8">
      <h2 className="text-3xl font-patrick text-foreground mb-6">{title}</h2>
      {children}
    </div>
  );
};

export default PageContent;
